/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_gov_006: Question = {
  id: 'gov-006-budget-biodiversite',
  oldId: '6',
  title: 'Allocation d\'un budget pour la biodiversité',
  number: '1.6',
  type: QuestionType.ACTIVITY,
  idEM: 13,
  frequency: 1,
  description: ['Une certaine partie du budget annuel de l’organisme municipal est alloué à des activités liées à la préservation de la biodiversité.'],
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      score: '0',
      scoringFct: (data: string[]) => parseFloat(data[0]),
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_gov_006_v2: Question = question_gov_006;
export const question_gov_006_v3: Question = question_gov_006;
